// 記事本文中の h2 要素に id 属性を設定
const $root = $('.article-body');
const $h2 = $root.find('h2'); // console.log($h2.length);

$h2.each(function (index, elem) {
  const $this = $(elem);
  $this.attr('id', `h2_${index + 1}`);
});